export default {
      id: "icon-info-usage",
      viewBox: "-2 -2 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-info",
      toString: function () {
        return this.url;
      }
    }